import { getRootNode } from 'components/Editor/EditorContext/selectors/block'
import NodeContainer from 'components/Editor/cource/layout/Node'
import { BlockMode } from 'services/Store/Project/enums'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getBlocks, getSectionId } from 'services/Store/Project/selectors'

import * as s from './TestGeneralFeedbackElement.module.scss'
import type { TestGeneralFeedbackElementType } from './testGeneralFeedbackTypes'

const TestGeneralFeedbackElementPreview: TestGeneralFeedbackElementType = ({ mode, block }) => {
  const sectionId = useProjectContext(getSectionId) || block?.sectionId || undefined
  const blocks = useProjectContext(getBlocks, sectionId)
  const filteredBlocks = blocks.filter((block) => block.mode === BlockMode.questions)

  return (
    <div className={s.root}>
      {filteredBlocks.map((block) => {
        const root = getRootNode(block)
        return <NodeContainer block={block} id={root.id} key={block.uuid} mode={mode} />
      })}
    </div>
  )
}

export default TestGeneralFeedbackElementPreview
